/*
 * Copyright (C) [2025] [Netzint GmbH]
 * All rights reserved.
 *
 * This software is dual-licensed under the terms of:
 *
 * 1. The GNU Affero General Public License (AGPL-3.0-or-later), as published by the Free Software Foundation.
 *    You may use, modify and distribute this software under the terms of the AGPL, provided that you comply with its conditions.
 *
 *    A copy of the license can be found at: https://www.gnu.org/licenses/agpl-3.0.html
 *
 * OR
 *
 * 2. A commercial license agreement with Netzint GmbH. Licensees holding a valid commercial license from Netzint GmbH
 *    may use this software in accordance with the terms contained in such written agreement, without the obligations imposed by the AGPL.
 *
 * If you are uncertain which license applies to your use case, please contact us at info@netzint.de for clarification.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from '@fortawesome/free-solid-svg-icons';
import cn from '../utils/cn';
import { Button } from './Button';

const NUMBER_PAD_DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

interface NumberPadProps {
  onPress: (digit: string) => void;
  onClear: () => void;
  variant?: 'default' | 'dialog' | 'login';
}

const NumberPad: React.FC<NumberPadProps> = ({ onPress, onClear, variant = 'default' }) => (
  <div className="m-4 grid max-w-52 grid-cols-3 gap-2">
    {NUMBER_PAD_DIGITS.map((digit) => (
      <Button
        key={digit}
        variant="btn-outline"
        type="button"
        className={cn(
          'aspect-square hover:bg-ciGrey/10',
          variant === 'login' && 'border-darkGrey text-darkGrey hover:bg-darkGrey/10',
        )}
        onClick={() => onPress(digit)}
      >
        {digit}
      </Button>
    ))}
    <Button
      variant="btn-outline"
      type="button"
      className={cn(
        'w-[136px] hover:bg-ciGrey/10',
        variant === 'login' && 'border-darkGrey text-darkGrey hover:bg-darkGrey/10',
      )}
      onClick={onClear}
    >
      <FontAwesomeIcon icon={faBackspace} />
    </Button>
  </div>
);

export default NumberPad;
export type { NumberPadProps };
